module.exports = __webpack_public_path__ + "img/logout.2866f3d5.png";